angular.module("indicators_types")

    .controller('IndicatorsTypesListCtrl', ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', '$state', function (LoginService, $rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, $state) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("INDICATORS_TYPES_WRITE");

        $rootScope.title = $filter('translate')('indicators_types.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('indicators_types.list') }
        ];

        $scope.gridOptionsIndicatorsTypes = {
            pdfTitle: $filter('translate')('indicators_types.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
              { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
              { name: 'name', displayName: $filter('translate')('indicators_types.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('indicators_types.button_edit'), action: 'ui-sref="indicators_types.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('indicators_types.button_delete'), action: 'ng-click="grid.appScope.BorrarDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                return Restangular.all('IndicatorsTypes').getList(options);
            }
            
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("indicators_types.edit", { id: rowEntity.id });
        }

        $scope.BorrarDialog = function (id,name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('indicators_types.delete'),
                message: $filter('translate')('indicators_types.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('IndicatorsTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('indicators_types.delete_success'));
                        $scope.gridOptionsIndicatorsTypes.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };


    }])

;